if ($(".home-kv").length) {
  const off_x = $(".p-pageTtl__txt:first").offset();
  $(".home-kv__slideInfo").css("padding-left", off_x.left);
  $(window).on("load", function () {
    $(".home-kv .co-menus .co-menus__inner div p").each(function (index, element) {
      let x = $(this).height();
      if (x > 47) {
        $(this).addClass("over-text");
      } else {
        $(this).css("max-hight", "3.6em");
      }
    });
    let co_height = $(".co-menus").height();
    co_height = co_height - 36;
    let vn = $(".co-menus__inner").length;
    co_height = co_height / vn;
    $(".home-kv .co-menus .co-menus__inner").each(function (index, element) {
      $(this).css("height", co_height);
    });
  });
}

const honeycombList = $(".home-mv__honeycomb ul");
const honeycombNum = honeycombList.children().length;
const tempArr = [];
if (honeycombNum) {
  // 元のリストのクローンを作成し、出現するリスト（appearList）を作成
  let appearList = honeycombList.clone().addClass("appear");
  // 元のリストはフェードアウト用のクラス（.fadeOut）を付与
  let fadeOutList = honeycombList.addClass("fadeOut");
  // appearListの中身をランダムに入れ替える
  appearListShuffle();
  // appearListを追加する（z-indexでフェードアウトさせる要素の裏になる様に設定）
  honeycombList.parent().append(appearList);

  setInterval(() => {
    doCrossFadeAnimation();
  }, 8000);

  function doCrossFadeAnimation() {
    fadeOutList.fadeOut(2000, function () {
      // 表示中のappearListのクラスをappear → fadeOutに置き換えて新たなfadeOutListとする
      fadeOutList = appearList.removeClass("appear").addClass("fadeOut");

      // 非表示になっている元fadeOutListのクラスを置き換えて、新たなappearListとする
      appearList = $(".fadeOut:hidden").removeClass("fadeOut").addClass("appear");
      // appearListの中身をランダムに入れ替える
      appearListShuffle();
      //appearListを表示させておく
      appearList.show();
    });
  }

  function appearListShuffle() {
    // 作業用配列を空にする
    tempArr.length = 0;
    appearList.children("li").each(function () {
      tempArr.push($(this));
    });
    // 要素をランダムに入れ替え
    for (let i = honeycombNum - 1; i >= 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [tempArr[i], tempArr[j]] = [tempArr[j], tempArr[i]];
    }
    // 入れ替えた要素で置き換える
    appearList.empty();
    $.each(tempArr, function () {
      appearList.prepend($(this));
    });
  }
}

// ニュースで最新のニュースが非表示で過去のニュースが一番上に来た場合にborderを消す
const newsItem = $(".home-news-bottom__post:visible").first();
if (newsItem.length > 0) {
  newsItem.css("border-top", "none");
}
